import {ITextBoxSchema} from './TextBox';
import {isNullOrEmpty} from "../../Utils";
import { replace, findIndex, isEmpty, isObject } from 'lodash';
import { Errors } from "../../../messages";
import {isUndefined} from "util";
import {IControlError, IControlSchema} from "../../Controls";
import { validate } from '../standart/DynamicGridPanel/validate';
import {ICalendarSchema} from "./Calendar/Calendar";
import {Dictionary} from "../../../types/Dictionary";

interface ErrorResult {
  isError: boolean,
  message: string
}

export interface ErrorField {
  controlId: string;
  control: any;
  error: {
    message: string;
    isFrontValidation: boolean;
  } | undefined
}


const isInteger = (value: string) => !isNullOrEmpty(value) && /^\d+$/.test(value);

const isCurrency = (value: string) => !isNullOrEmpty(value) && /^-{1}|\d+\.\d{1,2}$/.test(value) || /^\d+$/.test(value)

const isMin = (value: string, min: number) =>
    min && parseFloat(replace(value,',','.')) < min

const isMax = (value: string, max: number) =>
    max && parseFloat(replace(value,',','.')) > max


export function TextBoxValidate(value: string, schema: ITextBoxSchema) : ErrorResult {
  const error : ErrorResult = { isError: false, message: undefined };
  const type: string = schema.type.toUpperCase();
  if(schema.required && value && !schema.disabled){
    switch (type) {
      case "NUMBER":
        if (schema.isInteger && !isInteger(value)) {
          error.message = 'Неверный формат поля';
        } if (!schema.isInteger && !isCurrency(value)){
          error.message = 'Неверный формат поля';
        }else if (isMin(value, schema.min)) {
          error.message = Errors["MIN_VALUE"].ru + ": " + schema.min;
        } else if (isMax(value, schema.max)) {
          error.message = Errors["MAX_VALUE"].ru + ": " + schema.max
        }
        break;
      default:
        if(value.length > schema.maxLength) {
          error.message = `${Errors["MAX_LENGTH"].ru} : ${schema.maxLength}`;
        }
        break;
    }
  }
  error.isError = !isUndefined(error.message);
  return error;
}

interface IValueCheked {
  value: {
    checked: boolean;
  }
}

export function isGroupCheck(ctrl: any, objValue: any): boolean {
  if (ctrl.type.toUpperCase() === 'GROUP') {
    if (isUndefined(ctrl.visible)) return true;
    else return ctrl.visible;
  } else if (ctrl.type.toUpperCase() === 'PANEL') {

    if(isUndefined(ctrl.visible) && ctrl.required) return true;
    else if(ctrl.visible && ctrl.required) return true;

    if(!isUndefined(ctrl.visible) && !ctrl.required){
      if(ctrl.visible && isObject(objValue)){
        return ctrl.visible && (objValue as IValueCheked).value.checked;
      }else if(ctrl.visible && isUndefined(objValue)){
        return false;
      }
    }else if(isObject(objValue)){
      return (objValue as IValueCheked).value.checked
    }
  }

  return false;
}

export function* onValidate(controls: Array<IControlSchema>, values: Array<any>, form: any, validateEmptyRequired: boolean, errors: Dictionary<IControlError | undefined>): Iterable<ErrorField> {
  for (let ctrl of controls) {
    yield* validateControl(ctrl, values, form, validateEmptyRequired, errors);
  }
  return;
}

const controlsWithCommonValidationOnly = {
  OBJECT: true,
  SERVICETABLE: true,
  LABEL: true,
  GROUP: true,
  PANEL: true,
  DYNAMICGRIDPANEL: true,
  TOTALHEADER: true
};

export function GridValidate(value: Array<any>) : ErrorResult {
  const error : ErrorResult = { isError: false, message: undefined };

  value.forEach((elem) => {
    for (let key in elem) {
      if (elem.hasOwnProperty(key)) {
        if (elem[key] === null) {
          error.message = "Не заполнено обязательное поле в таблице";
        }
      }
    }
  })

  error.isError = !!error.message;

  return error;
}

export function* validateControl(ctrl: IControlSchema, values: Array<any>, form: any, validateEmptyRequired: boolean, errors: Dictionary<IControlError | undefined>): Iterable<ErrorField> {
  const valueIdx = findIndex(values, (val: any) => val.controlid === ctrl.id);
  const error = errors[ctrl.id];
  if(error && !controlsWithCommonValidationOnly[ctrl.type.toUpperCase()]) {
    yield {controlId: ctrl.id, control: ctrl, error: {message: error.message, isFrontValidation: error.isFrontValidation}};
    return;
  }
  if (!ctrl.hasOwnProperty('controls') && (isUndefined(ctrl.visible) || ctrl.visible)) {
    let idx = findIndex(values, (val: any) => val.controlid === ctrl.id);
    if (idx === -1 && ctrl.required) {
      let message = '';
      switch (ctrl.type.toUpperCase()) {
        case 'CHECKBOX': message = 'Не принято обязательное соглашение';
          break;
        case 'GRID': message = 'Таблица должна содержать хотя бы одну запись';
          break;
        case 'RADIOBUTTON': message = 'Не выбран ни один из пунктов';
          break;
        default: message = 'Не заполнено обязательное поле';
          break;
      }
      
      if(validateEmptyRequired) {
        yield {controlId: ctrl.id, control: ctrl, error: {message, isFrontValidation: true}};
      } else {
        yield {controlId: ctrl.id, control: ctrl, error: undefined};
      }
      return;
    } else if (idx !== -1 && ctrl.required) {
      switch (ctrl.type.toUpperCase()) {
        case 'TEXTBOX':
        case 'TEXTAREA':
        case 'NUMBER' : {
          const error = TextBoxValidate(values[idx].value, (ctrl as ITextBoxSchema));
          if (error.isError) {
            yield {controlId: ctrl.id, control: ctrl, error: {message: error.message, isFrontValidation: true}};
            return;
          }
          break;
        }
        case 'CALENDAR': {
          const value = values[idx].value;
          if((ctrl as ICalendarSchema).finishDate !== null) {
            if(isEmpty(value.beginDate) || isEmpty(value.finishDate)) {
              if(validateEmptyRequired) {
                yield {
                  controlId: ctrl.id,
                  control: ctrl,
                  error: {message: 'Не заполнено обязательное поле', isFrontValidation: true}
                };
              } else {
                yield {
                  controlId: ctrl.id,
                  control: ctrl,
                  error: undefined
                };
              }
              return;
            }
          }
          break;
        }
        case "GRID": 
          const error = GridValidate(values[idx].value);

          if (error.isError) {
            yield {controlId: ctrl.id, control: ctrl, error: {message: error.message, isFrontValidation: true}};
            return;
          }

          break;
      }
    }
    else {
      if (["EquipmentRentPrepayment", "TestingPrepaid", "CreatePrototypesPrepaid"].concat(form) && ctrl.id === "AffiliateFlag") {
        const vl = values[idx].value;
        if (vl === "Подрядчик аффилирован") {
          switch (form) {
            case "EquipmentRentPrepayment": {
              yield {
                controlId: ctrl.id,
                control: ctrl,
                error: {
                  message: "Услуги аффилированного ЦКП могут быть только компенсированы. Необходимо заполнить заявку вида Аренда оборудования (Компенсация)",
                  isFrontValidation: true
                }
              };
              return;
            }
            case "TestingPrepaid": {
              yield {
                controlId: ctrl.id,
                control: ctrl,
                error: {
                  message: "Услуги аффилированного ЦКП могут быть только компенсированы. Необходимо заполнить заявку вида Проведение испытаний (Компенсация)",
                  isFrontValidation: true
                }
              };
              return;
            }
            case "CreatePrototypesPrepaid": {
              yield {
                controlId: ctrl.id,
                control: ctrl,
                error: {
                  message: "Услуги аффилированного ЦКП могут быть только компенсированы. Необходимо заполнить заявку вида Создание прототипов (Компенсация)",
                  isFrontValidation: true
                }
              };
              return;
            }
          }
        }
      }
    }
  } else if (isGroupCheck(ctrl, values[valueIdx])) {
    if (ctrl.type.toUpperCase() === "PANEL" &&
        valueIdx > -1 &&
        !isEmpty(values[valueIdx].value.rows)) {

      const rows = values[valueIdx].value.rows;
      for (let row of rows) {
        for (let controlRow of row.controls) {
          const index = findIndex(values, (val: any) => val.controlid === controlRow.id);
          const idxCtrl = findIndex(ctrl["controls"], (obj: any) => obj.id === controlRow.name),
              childControl = ctrl["controls"][idxCtrl];

          if (index === -1 && childControl.required) {
            let message = '';
            switch (ctrl.type.toUpperCase()) {
              case 'CHECKBOX': message = 'Не принято обязательное соглашение';
                break;
              case 'GRID': message = 'Таблица должна содержать хотя бы одну запись';
                break;
              case 'RADIOBUTTON': message = 'Не выбран, не одни из пунктов ';
                break;
              default: message = 'Не заполнено обязательное поле';
                break;
            }

            if(validateEmptyRequired) {
              yield {controlId: controlRow.id, control: ctrl, error: {message, isFrontValidation: true}};
            } else {
              yield {controlId: controlRow.id, control: ctrl, error: undefined};
            }
          }else if (index !== -1 && ctrl.required) {
            switch (ctrl.type.toUpperCase()) {
              case 'TEXTBOX':
              case 'TEXTAREA':
              case 'NUMBER' :
                const error = TextBoxValidate(values[index].value, (ctrl as ITextBoxSchema));
                if (error.isError) {
                  yield {controlId: ctrl.id, control: ctrl, error: {message: error.message, isFrontValidation: true}};
                }
                break;
            }
          }

        }
      }
    }

    let error = onValidate(ctrl["controls"], values, form, validateEmptyRequired, errors);
    if (error !== null) {
      yield* error;
      return;
    }
  } else if (ctrl.type.toUpperCase() === "DYNAMICGRIDPANEL") {
    if (valueIdx === -1) {
      if(validateEmptyRequired) {
        yield {
          controlId: ctrl.id,
          control: ctrl,
          error: {message: 'Не заполненен обязательный раздел', isFrontValidation: true}
        };
      }
      else {
        yield {
          controlId: ctrl.id,
          control: ctrl,
          error: undefined
        };
      }
      return;
    }
    const state = values[valueIdx].value;
    yield* validate(state, values, validateEmptyRequired);
  }
  yield {controlId: ctrl.id, control: ctrl, error: undefined};
  return;
}


// WEBPACK FOOTER //
// ./src/components/controls/standart/validate.ts